module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/NATURAL SCIENCES-4728761110dc7ade755ad6d0108545d3.png";